export let badge = {
	style: '',
	id: '',
	color: { text: '', bg: '' },
	count: 0,
};

export const setter = (props) => {
	badge = {
		...badge,
		...props,
	};
};
